import { FacilityMaintenanceWorkOrder } from "kinnect-models";
import { KActionDialog } from "kinnect-general";

export default {
	name: "WorkOrderDeleteDialog",

	props: {
		...KActionDialog.options.props,

		confirmButtonColor: {
			...KActionDialog.options.props.confirmButtonColor,
			default: "error"
		},

		confirmButtonText: {
			...KActionDialog.options.props.confirmButtonText,
			default: "Delete"
		},

		item: {
			required: true,
			type: FacilityMaintenanceWorkOrder
		},

		title: {
			...KActionDialog.options.props.title,
			default: "Delete Work Order"
		}
	},

	render() {
		return <KActionDialog
			attrs={{
				...this.$props,
				loading: this.$wait.is( "delete work order" )
			}}
			on={{ ...this.$listeners }}
			scopedSlots={{
				default: () => <div>Are you sure you want to delete this work order for <strong>{this.item.location.name}</strong>?</div>,

				...this.$scopedSlots
			}}
		></KActionDialog>;
	}
};
